import { TranslateFn } from '~/shared/utils/translation/hooks/useTranslation';
import { MapMarker } from '../models';
import { Store } from '~/lib/data-contract/salesforce';

interface OpeningHour {
    isOpen: boolean;
    willOpenToday: boolean;
    day: string;
    opens: string | null;
    closes: string | null;
}

type StoreHoursOption = Pick<Store, 'c_openingStatusToday' | 'c_storeClosedReason'>;

export const getStoreHoursText = (
    translate: TranslateFn,
    openingHours: OpeningHour[],
    storeOption?: MapMarker | StoreHoursOption,
): string => {
    const isCloseAll = openingHours.every((item) => item.opens === null);
    const today = openingHours[0] ?? {};
    const willOpen = today.willOpenToday;
    const storeNotTemporaryClose =
        today.day === storeOption?.c_openingStatusToday?.day &&
        !storeOption?.c_openingStatusToday?.isClosedToday;
    const storeOpened = today?.isOpen;
    const openingHour = openingHours.slice(1).find((schedule) => schedule.opens && schedule.closes);

    if (isCloseAll) {
        return storeOption?.c_storeClosedReason ?? '';
    }

    if (storeNotTemporaryClose) {
        if (storeOpened) {
            return translate('pdp.closesAt', {
                closesAt: String(today.closes),
            });
        }

        return translate('pdp.opensAt', {
            opensAt: String(willOpen ? today.day : openingHour?.day)?.toLowerCase(),
            opensHour: String(willOpen ? today.opens : openingHour?.opens),
        });
    }

    return (
        storeOption?.c_openingStatusToday?.isClosedTodayMessage ??
        translate('pdp.opensAt', {
            opensAt: String(willOpen ? today.day : openingHour?.day)?.toLowerCase(),
            opensHour: String(willOpen ? today.opens : openingHour?.opens),
        })
    );
};
